import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CountryCodeList } from "../../../model/country_code/CountryCodeModel";

interface CountryCodeInterface {
  countryCodeDetail: CountryCodeList | null;
  textFielName: string;
}

const initialState: CountryCodeInterface = {
  countryCodeDetail: null,
  textFielName: "",
};

const countryCodeSlice = createSlice({
  name: "countryCode",
  initialState,
  reducers: {
    selectedCountryCodeTextField: (state, action: PayloadAction<string>) => {
      state.textFielName = action.payload;
    },
    clickedCountryCode: (state, action: PayloadAction<CountryCodeList>) => {
      state.countryCodeDetail = action.payload;
    },
  },
});

export const { clickedCountryCode, selectedCountryCodeTextField } =
  countryCodeSlice.actions;
export default countryCodeSlice.reducer;
